export default customElements.define('w-label-value-pair', class extends wealthify.CustomElementBaseClass {

    constructor () {
        
        // Pre-cache copyButton as dom cache wont
        // pick up elements inside nested components after initial construction
        const config = {cacheDom: ['data-copy-button', 'data-copy-button-aria']};
    
        super(config);
    }
    
    // Static

    static styleSelector = 'c-label-value-pair';

    static template = `
        <div class="${this.styleSelector}__container" data-root>
            <div>
                <div data-label></div>
                <div class="${this.styleSelector}__value" data-value></div>
            </div>
            <div class="${this.styleSelector}__button-container">
              <w-button-2 label="Copy" variant="tertiary" class="${this.styleSelector}__button" data-copy-button></w-button-2>
              <div class="u-display__hidden" data-copy-button-aria></div>
            </div>
        </div>
    `;

    static get observedProps () {
        return [
            new wealthify.Prop('label', {required: true}),
            new wealthify.Prop('value', {required: true}),
            new wealthify.Prop('value-formatted'),
            new wealthify.Prop('has-copy-button', {
                default: false,
                type: wealthify.propTypes.Boolean()
            })
        ];
    }

    // Private

    #copyAlertTimeout = 2000;
    get #value () {
        return this.valueFormatted ?? this.value;
    }

    // Public

    get propCallbacks () {
        return {
            label: () => {
                this.dom.label.innerHTML = this.label;
                this.#setButtonLabel();
            },
            value: () => {
                this.dom.value.textContent = this.#value;
            },
            valueFormatted: () => {},
            hasCopyButton: () => {
                const classListAction = this.hasCopyButton ? 'remove' : 'add';

                this.dom.copyButton.classList[classListAction]('u-display__none');
                this.dom.copyButton.addEventListener('click', () => this.#copyValueAndToggleButton());
            }
        };
    }

    #copyValueAndToggleButton () {
        navigator.clipboard.writeText(this.value);

        this.#toggleCopyButton(true);
        setTimeout(() => this.#toggleCopyButton(), this.#copyAlertTimeout);
    }

    #toggleCopyButton (clicked = false) {
        const classListAction = clicked ? 'add' : 'remove';

        this.classList[classListAction](`${this.constructor.styleSelector}--copied`);
        
        if (clicked) {
            this.dom.copyButtonAria.setAttribute('role', 'alert');
        } else {
            this.dom.copyButtonAria.removeAttribute('role');
        }

        this.#setButtonLabel(clicked);
    }

    #setButtonLabel (clicked = false) {
        const label = clicked
            ? `Copied <span class="u-display__hidden">&nbsp;${this.label} to clipboard</span>`
            : `Copy <span class="u-display__hidden">&nbsp;${this.label}</span>`;
        const accessibleLabel = clicked
            ? `Copied ${this.label} to clipboard`
            : `Copy ${this.label}`;

        this.dom.copyButton.label = label;
        this.dom.copyButton.iconright = clicked ? 'tick' : 'copy';
        this.dom.copyButtonAria.textContent = accessibleLabel;
    }
});